import React, { useEffect } from 'react';
import { useScriptLoader } from 'Src/hooks/use-script-loader/useScriptLoader';
import { useAppContext } from 'Context/ReactAppContext';
import config from 'Config/index';
import { classnames } from 'Utils/classnames/classnames.utils';
import { asConfigString, castAs } from 'Src/types/cast-helpers';
import type { HiPayClient } from 'Src/types/payment';

type PaypalFormProps = {
  isAbleToPay: boolean;
  onSuccess: (token: string) => void;
  amount: number;
  onError?: () => void;
};

export const PaypalForm = ({ isAbleToPay, onSuccess, amount }: PaypalFormProps) => {
  const { scriptLoaded } = useScriptLoader(asConfigString(config.get('psp.mhipay.script_url')));

  const { locale, currency } = useAppContext();

  useEffect(() => {
    if (scriptLoaded) {
      // eslint-disable-next-line new-cap
      const hipay = castAs<(config: Record<string, unknown>) => HiPayClient>(window.HiPay)({
        environment: asConfigString(config.get('psp.mhipay.environment')),
        password: asConfigString(config.get('psp.mhipay.password')),
        username: asConfigString(config.get('psp.mhipay.username')),
      });
      const instancePayPal = hipay.create('paypal', {
        canPayLater: false,
        request: {
          amount,
          currency,
          locale: locale.replace('-', '_'),
        },
        paypalButtonStyle: { shape: 'pill', color: 'gold', height: 45 },
        template: 'auto',
        selector: 'paypal-button',
      });

      instancePayPal.on('paymentAuthorized', function (data) {
        onSuccess(castAs<{ orderID: string }>(data).orderID);
      });
    }
  }, [scriptLoaded]);

  return (
    <div
      id="paypal-button"
      className={classnames('h-45', {
        hidden: !isAbleToPay,
      })}
    ></div>
  );
};
